import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { Alert } from '@mantine/core';
import type { ReactNode } from 'react';
import { Icon } from '../Spinner/Icon';
import type { AlertProps } from './AlertProps';

const AlertIcon = <Icon icon={faCircleCheck} />;

export function SuccessAlert(props: AlertProps): ReactNode {
	const icon = props.icon ?? AlertIcon;

	return (
		<Alert c={'green.9'} bg={'green.1'} variant="light" title={props.title} icon={icon}>
			{props.children}
		</Alert>
	);
}
